import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '@sla-ng/core';
import { PipesModule } from '../../pipes/pipes.module';
import { SlaSidenavComponent } from './sla-sidenav.component';

export * from './sla-sidenav.component';

@NgModule({
    declarations: [
        SlaSidenavComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        MatSidenavModule,
        MatListModule,
        MatIconModule,
        CoreModule,
        PipesModule,
        FormsModule,
        MatSlideToggleModule,
    ],
    exports: [
        SlaSidenavComponent,
    ],
})
export class SlaSidenavModule {}
